
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/reserver-voyages",
      function () {
        return require("private-next-pages/[region]/[resort]/reserver-voyages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/reserver-voyages"])
      });
    }
  